export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    LOGIN_DEVICE_AUTH_REQUIRED : 'LOGIN_DEVICE_AUTH_REQUIRED',
    LOGOUT: 'USERS_LOGOUT',
    LOGIN_DEVICE_AUTH_FAILURE : 'LOGIN_DEVICE_AUTH_FAILURE',
    LOGIN_SEND_DEVICE_AUTH_CODE : 'LOGIN_SEND_DEVICE_AUTH_CODE',
    LOGIN_VALIDATE_DEVICE_AUTH_CODE: 'LOGIN_VALIDATE_DEVICE_AUTH_CODE',
    LOGIN_WITH_HASH : "LOGIN_WITH_HASH",


    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',

    EMAIL_IN_USE: 'EMAIL_IN_USE',
    RECAPTCHA_FAILED: 'RECAPTCHA_FAILED',
    
    SET_LANGUAGE: "SET_LANGUAGE",
    USER_HASH_IN_USE: 'USER_HASH_IN_USE',

    USERS_REDIRECT_TO_REFINANCE_LOAN_REQUEST : "USERS_REDIRECT_TO_REFINANCE_LOAN_REQUEST",
    USERS_REDIRECT_TO_REFINANCE_LOAN_SUCCESS: "USERS_REDIRECT_TO_REFINANCE_LOAN_SUCCESS",

    GET_DISCLOSURES: "GET_DISCLOSURES",
    SET_DISCLOSURES: "SET_DISCLOSURES",
};



// WEBPACK FOOTER //
// ./src/_constants/user.constants.js